import { useEffect } from "react";
import { Link } from "react-router-dom";
import { GrainOverlay } from "../components/effects/GrainOverlay";
import { CustomCursor } from "../components/effects/CustomCursor";
import { HOST, CONTACT } from "../content";

export const LegalPage = ({ title, updated, children, testid }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="reg-app min-h-screen" data-testid={testid}>
      <GrainOverlay />
      <CustomCursor />
      <div className="relative max-w-3xl mx-auto px-6 sm:px-10 pt-16 pb-24">
        <Link to="/" data-cta className="mono text-[13px] tracking-widest text-[#FFC631] hover:text-[#ff3b44] transition-colors duration-200" data-testid="legal-back-link">
          ← BACK TO HOME
        </Link>
        <h1 className="serif font-black uppercase tracking-[-0.02em] text-4xl sm:text-5xl text-white mt-8">{title}</h1>
        <p className="mono text-[13px] tracking-widest text-white mt-4">LAST UPDATED: {updated}</p>
        <div className="mt-10 space-y-8">{children}</div>
        <div className="border-t border-white/10 mt-16 pt-8">
          <p className="mono text-[13px] text-white tracking-wider leading-relaxed">
            {HOST.name} · {HOST.company} · NMLS# {HOST.nmls} · Company NMLS# {HOST.companyNmls} · Licensed in {HOST.states}
            <br />
            {CONTACT.phone} · {CONTACT.email}
          </p>
        </div>
      </div>
    </div>
  );
};

export const LegalSection = ({ heading, children }) => (
  <section>
    <h2 className="serif font-bold uppercase text-lg text-[#FE0000] mb-3">{heading}</h2>
    <div className="text-[14px] text-white leading-[1.8] space-y-3">{children}</div>
  </section>
);
